import HotelRoomType from './HotelRoomType';
import { HotelApiApiHotelCityNameHotelNameRoomsGet } from '@clients/HotelApi';

export default class HotelRoomLoader {
    constructor(
        public cityName: string,
        public hotelName: string,
        public adultCount: number,
        public childCount: number,
        public roomCount: number,
        public fromDate: string,
        public toDate: string,
        public checkinHour: string,
        public checkoutHour: string
    ) {}

    async getRooms(): Promise<HotelRoomType[]> {
        const { data } = await HotelApiApiHotelCityNameHotelNameRoomsGet({
            cityName: this.cityName,
            hotelName: this.hotelName,
            from: dayConfig.gregory(this.fromDate).format(formatter()),
            to: dayConfig.gregory(this.toDate).format(formatter()),
            adultCount: this.adultCount,
            childrenCount: this.childCount,
            roomCount: this.roomCount,
        });
        const rooms = data.rooms || [];
        return rooms.map(
            r =>
                new HotelRoomType({
                    ...r,
                    checkinHour: this.checkinHour,
                    checkoutHour: this.checkinHour,
                })
        );
    }
}
